import type { ViewportContextType } from "./types";

export const VIEWPORT_PROVIDER_INITIAL_STATE: ViewportContextType = {
  isDeviceMobile: false,
  isViewportMobile: false,
  isMobileMode: false,
};
